<template>
	<div class="text-center w-75 mx-auto">
		<div class="mt-5">
			<img-default custom_class="mb-3" />
			<p class="pt-3 heading-4 text-22 mb-2">Access Denied</p>
      <p class="body-2 mb-4 w-75 mx-auto">This area is for development only</p>
		</div>
	</div>
</template>
<script>
	export default{
		metaInfo(){
    	return {title:'Page not found'}
    }
	}
</script>


// WEBPACK FOOTER //
// src/pages/general/DevelopmentOnly.vue